const resources = {
    seeDetails: 'See Details'
};

export default function getResource(label) {
    return resources[label];
}
